module.exports = __webpack_public_path__ + "img/zalo-OA-icon.90ea24bf.png";